import type { CSSProperties } from "react";

type LogoTheme = "auto" | "dark" | "light";

type LumikaLogoProps = {
  theme?: LogoTheme;
  size?: number;
  className?: string;
  title?: string;
  style?: CSSProperties;
};

const DARK_SRC = "/lumika-dark.svg";
const LIGHT_SRC = "/lumika-light.svg";

export function LumikaLogo({
  theme = "auto",
  size = 32,
  className,
  title = "lumika",
  style,
}: LumikaLogoProps) {
  const dimension = `${size}px`;
  const baseStyle: CSSProperties = { width: dimension, height: dimension, ...(style ?? {}) };

  if (theme === "dark") {
    return (
      <img
        src={DARK_SRC}
        alt={title}
        width={size}
        height={size}
        className={className}
        style={baseStyle}
        draggable={false}
      />
    );
  }

  if (theme === "light") {
    return (
      <img
        src={LIGHT_SRC}
        alt={title}
        width={size}
        height={size}
        className={className}
        style={baseStyle}
        draggable={false}
      />
    );
  }

  return (
    <picture className={className} style={baseStyle}>
      <source srcSet={LIGHT_SRC} media="(prefers-color-scheme: dark)" />
      <img
        src={DARK_SRC}
        alt={title}
        width={size}
        height={size}
        style={baseStyle}
        draggable={false}
      />
    </picture>
  );
}
